export function createRng(seed) {
    // mulberry32 — small, fast, deterministic, well-distributed
    let state = (seed >>> 0) || 1;
    const next = () => {
        state = (state + 0x6D2B79F5) >>> 0;
        let t = state;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
    return {
        next,
        intRange: (minIncl, maxIncl) => minIncl + Math.floor(next() * (maxIncl - minIncl + 1)),
        pick: (arr) => {
            if (arr.length === 0)
                throw new Error('rng.pick: empty array');
            return arr[Math.floor(next() * arr.length)];
        },
        chance: (p) => next() < p
    };
}
